import { useState, useEffect } from 'react';
import { Box } from '@mantine/core';

import * as actions from '../../../actions/Lote';
import TabAvaliacoes from './TabAvaliacoes';
import { useAppDispatch } from '../../../store/hooks';
import type { Unidade } from '../../../store/types';
import { DetailSkeleton } from '../../../components/TableSkeleton';
import EmptyState from '../../../components/EmptyState';

interface InnerViewProps {
  unidadeId: number;
  onLoad?: (inscricao: string) => void;
}

export default function InnerView({ unidadeId, onLoad }: InnerViewProps) {
  const dispatch = useAppDispatch();
  const [unidade, setUnidade] = useState<Unidade | null>(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!unidadeId) return;

    setLoading(true);
    setFailed(false);
    dispatch((actions as any).getUnidade(
      unidadeId,
      '[VIEW_ITEM]',
      ({ data }: { data: Unidade }) => {
        setUnidade(data);
        setLoading(false);
        if (onLoad) onLoad(data.inscricao);
      },
      () => { setFailed(true); setLoading(false); },
    ));

    return () => {
      setUnidade(null);
    };
  }, [unidadeId]);

  if (loading) return <DetailSkeleton lines={6} />;
  if (failed || !unidade) return <EmptyState label="Não foi possível carregar a unidade" py="md" />;

  return (
    <Box>
      <TabAvaliacoes
        unidadeId={unidade.id}
        unidadeFieldItemGroups={unidade.fieldItemGroups}
        avaliacoes={unidade.avaliacoes}
      />
    </Box>
  );
}
